/* eslint-disable */
import * as Types from '../../../clients/graphqlTypes.js';

import { gql } from '@apollo/client';
import { UseDownloadQuotePdfOptions_QuoteFragmentDoc } from '../quotes/hooks/useDownloadQuotePdfOptions.generated.js';
import * as Apollo from '@apollo/client';
const defaultOptions = {} as const;
export type GenerateQuotePdfModal_QuoteFragment = { __typename: 'Quote', id: string, owningSystemOrganisationId: string, templateOriginQuoteId?: string | null, agreedCalculation?: { __typename: 'ItemCalculation', materialBuyingPricePerUnit: number, discountRate: number, materialMargin: number, materialPriceDiscountedSubTotal: number, materialPricePerUnit: number, materialPriceSubTotal: number, materialFactor: number, priceNetTotal: number, pricePerUnit: number, priceSubTotal: number, priceTotal: number, priceVatTotal: number, quantity: number, quantityUnit: Types.QuantityUnit, timePerUnit: number, timeTotal: number, workSellingRate: number, workBuyingRate: number, workRate: number, workBuyingPricePerUnit: number, workPriceDiscountedSubTotal: number, workPricePerUnit: number, workPriceSubTotal: number, workFactor: number, vatRate: number } | null };

export type GenerateQuotePdfModal_PdfLetterheadsQueryVariables = Types.Exact<{ [key: string]: never; }>;


export type GenerateQuotePdfModal_PdfLetterheadsQuery = { viewer?: { __typename: 'MissingCapabilities' } | { __typename: 'MissingPermissions' } | { __typename: 'Viewer', id: string, organisation: { __typename: 'ViewerOrganisation', id: string, pdfLetterheads: Array<{ __typename: 'PdfLetterheadOption', id: string, name: string, isDefault: boolean }> } } | null };

export const GenerateQuotePdfModal_QuoteFragmentDoc = gql`
    fragment GenerateQuotePdfModal_Quote on Quote {
  id
  owningSystemOrganisationId
  ...UseDownloadQuotePdfOptions_Quote
}
    ${UseDownloadQuotePdfOptions_QuoteFragmentDoc}`;
export const GenerateQuotePdfModal_PdfLetterheadsDocument = gql`
    query GenerateQuotePdfModal_PdfLetterheads {
  viewer {
    ... on Viewer {
      id
      organisation {
        id
        pdfLetterheads {
          id
          name
          isDefault
        }
      }
    }
  }
}
    `;

/**
 * __useGenerateQuotePdfModal_PdfLetterheadsQuery__
 *
 * To run a query within a React component, call `useGenerateQuotePdfModal_PdfLetterheadsQuery` and pass it any options that fit your needs.
 * When your component renders, `useGenerateQuotePdfModal_PdfLetterheadsQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useGenerateQuotePdfModal_PdfLetterheadsQuery({
 *   variables: {
 *   },
 * });
 */
export function useGenerateQuotePdfModal_PdfLetterheadsQuery(baseOptions?: Apollo.QueryHookOptions<GenerateQuotePdfModal_PdfLetterheadsQuery, GenerateQuotePdfModal_PdfLetterheadsQueryVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<GenerateQuotePdfModal_PdfLetterheadsQuery, GenerateQuotePdfModal_PdfLetterheadsQueryVariables>(GenerateQuotePdfModal_PdfLetterheadsDocument, options);
      }
export function useGenerateQuotePdfModal_PdfLetterheadsLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<GenerateQuotePdfModal_PdfLetterheadsQuery, GenerateQuotePdfModal_PdfLetterheadsQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<GenerateQuotePdfModal_PdfLetterheadsQuery, GenerateQuotePdfModal_PdfLetterheadsQueryVariables>(GenerateQuotePdfModal_PdfLetterheadsDocument, options);
        }
export function useGenerateQuotePdfModal_PdfLetterheadsSuspenseQuery(baseOptions?: Apollo.SkipToken | Apollo.SuspenseQueryHookOptions<GenerateQuotePdfModal_PdfLetterheadsQuery, GenerateQuotePdfModal_PdfLetterheadsQueryVariables>) {
          const options = baseOptions === Apollo.skipToken ? baseOptions : {...defaultOptions, ...baseOptions}
          return Apollo.useSuspenseQuery<GenerateQuotePdfModal_PdfLetterheadsQuery, GenerateQuotePdfModal_PdfLetterheadsQueryVariables>(GenerateQuotePdfModal_PdfLetterheadsDocument, options);
        }
export type GenerateQuotePdfModal_PdfLetterheadsQueryHookResult = ReturnType<typeof useGenerateQuotePdfModal_PdfLetterheadsQuery>;
export type GenerateQuotePdfModal_PdfLetterheadsLazyQueryHookResult = ReturnType<typeof useGenerateQuotePdfModal_PdfLetterheadsLazyQuery>;
export type GenerateQuotePdfModal_PdfLetterheadsSuspenseQueryHookResult = ReturnType<typeof useGenerateQuotePdfModal_PdfLetterheadsSuspenseQuery>;
export type GenerateQuotePdfModal_PdfLetterheadsQueryResult = Apollo.QueryResult<GenerateQuotePdfModal_PdfLetterheadsQuery, GenerateQuotePdfModal_PdfLetterheadsQueryVariables>;